import { render } from "./HelpRtb.vue?vue&type=template&id=bd706a6c&scoped=true"
import script from "./HelpRtb.vue?vue&type=script&lang=js"
export * from "./HelpRtb.vue?vue&type=script&lang=js"

import "./HelpRtb.vue?vue&type=style&index=0&id=bd706a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd706a6c"]])

export default __exports__